import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, ArrowRightIcon } from 'lucide-react';
const posts = [{
  id: 'morning-ritual',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/befc2cff-e46f-4dcf-a941-499ff0430b10.jpg',
  alt: 'Ritual de mañana — journaling y té al amanecer'
}, {
  id: 'gentle-movement',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/8975dabd-e7ca-4ed1-93e1-c5f17ffdfb56.jpg',
  alt: 'Movimiento suave — estiramientos al atardecer'
}, {
  id: 'evening-ritual',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/9ef084e1-83c7-478c-9cb1-d586b53dc553.jpg',
  alt: 'Ritual nocturno — vela, libro y calma'
}, {
  id: 'meal-prep',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/0f9711d4-2866-43e6-bd9d-8a9a23e76645.jpg',
  alt: 'Comidas simples — plato saludable y elegante'
}];
const INSTAGRAM_URL = 'https://www.instagram.com/metodo.her/';
export function FinalCTASection() {
  return <section className="bg-gradient-section py-16 md:py-20 px-4 md:px-8 relative overflow-hidden" style={{
    paddingTop: "23px"
  }} data-id="element-113" data-mp="26v0yay5eyu1q">
      <div className="max-w-3xl mx-auto relative z-10 space-y-14" data-id="element-114" data-mp="21wz53ke9xecj">
        {/* Marca + Instagram — cierre de marca, no una segunda oferta */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-115" data-mp="1x34nqnm55bgm">
          <p className="uppercase tracking-[0.24em] text-[#C8A870] font-semibold text-[11px] mb-4" style={{
          fontFamily: 'sans-serif',
          fontSize: "13px"
        }} data-id="element-116" data-mp="1j56okpge5llp">
            CONOCÉ MÁS DE H.E.R
          </p>

          <h2 className="font-display text-[28px] md:text-[36px] leading-tight text-foreground max-w-lg mx-auto" data-id="element-117" data-mp="198tkcxn7zpcp">
            ¿Tenés alguna consulta?
          </h2>

          <p className="mt-4 font-body text-foreground/60 max-w-md mx-auto text-[15px] md:text-[16px] leading-relaxed" style={{
          fontSize: "17px"
        }} data-id="element-118" data-mp="33krquru5a74w">
            Estamos en Instagram para acompañarte y responder tus dudas sobre H.E.R.
          </p>

          {/* Grid de publicaciones — carrusel en mobile, grilla en desktop */}
          <div className="mt-10 flex gap-4 overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-4 md:overflow-visible px-1 md:px-0 pb-2 scrollbar-hide" data-id="element-119" data-mp="rzraozk0uxyp">
            {posts.map(post => <a key={post.id} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label={`Ver publicación en Instagram: ${post.alt}`} className="group shrink-0 basis-[70%] md:basis-auto snap-center relative aspect-square rounded-[10px] overflow-hidden border-[0.5px] border-gold/15" data-id="element-120" data-mp="1knww7oiwgqzl">
                <img src={post.img} alt={post.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-121" data-mp="1fm7n4ef8mne5" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/35 transition-colors duration-200 ease-out flex items-center justify-center" data-id="element-122" data-mp="4953tblr7jqa">
                  <InstagramIcon className="w-6 h-6 text-[#F0E8D8] opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-out" data-id="element-123" data-mp="3nve0tbwkpmqs" />
                </div>
              </a>)}
          </div>

          {/* Identificador + CTA secundario */}
          <div className="mt-8 flex flex-col items-center gap-5" data-id="element-124" data-mp="1ogvfk0bq8qq">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#C8A870] font-body font-medium text-[15px] hover:text-[#E8D5B0] transition-colors duration-200 ease-out" data-id="element-125" data-mp="3a2xua14gr6l4">
              <InstagramIcon className="w-4 h-4" data-id="element-126" data-mp="3jv3j51zf57w3" />
              @metodo.her
            </a>

            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-gold/40 text-[#C8A870] hover:border-gold hover:bg-gold/[0.06] px-6 py-3 rounded-[3px] uppercase tracking-[0.14em] text-[12px] font-semibold transition-colors duration-200 ease-out" data-id="element-127" data-mp="3f225exay7ee3">
              Ver Instagram
              <ArrowRightIcon className="w-3.5 h-3.5 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-128" data-mp="1tocwvy4z3073" />
            </a>
          </div>
        </motion.div>

        {/* Footer */}
        <motion.footer initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="text-center space-y-4 pt-12 border-t border-border/20" data-id="element-129" data-mp="23e67avtdp99r">
          <p className="text-foreground/70 font-body text-sm font-medium" data-id="element-130" data-mp="2deglojr5gmqi">
            © 2026 Protocolo H.E.R. — Todos los derechos reservados.
          </p>
          <p className="text-foreground/60 font-body text-sm max-w-2xl mx-auto leading-relaxed" data-id="element-131" data-mp="2mbz9fvw6hf63">
            Descargo de responsabilidad médico: Este producto ofrece información
            general sobre salud hormonal. No constituye consejo médico
            profesional. Consulta siempre a un profesional de la salud antes de
            comenzar cualquier programa de dieta o ejercicio.
          </p>
        </motion.footer>
      </div>
    </section>;
}